export default "__VITE_ASSET__38c69c51__"